import { BaseNode, NodeBadge, shortUrl } from './BaseNode';

export function HttpPaginateNode({
  data,
}: {
  data: { label: string; url?: string; pagination?: { strategy?: string }; alias?: string };
}) {
  return (
    <BaseNode
      type="http-paginate"
      label={data.label}
      alias={data.alias}
      badge={data.pagination?.strategy && <NodeBadge>{data.pagination.strategy}</NodeBadge>}
      lines={[{ text: shortUrl(data.url), mono: true }]}
    />
  );
}
